import { Flex } from '@ergolabs/ui-kit';
import React, { ReactNode } from 'react';
import { map, Observable, zip } from 'rxjs';

import { getErgopadWhitelistForm } from './ErgopadWhitelistForm/getErgopadWhitelistForm';
import { getSpectrumWhitelistForm } from './SpectrumWhitelistForm/getSpectrumWhitelistForm';

export const getCommunityWhiteListForm = (): Observable<
  ReactNode | ReactNode[] | string | undefined
> =>
  zip(getSpectrumWhitelistForm(), getErgopadWhitelistForm()).pipe(
    map(([spectrumWhitelistForm, ergopadWhitelistForm]) => (
      <Flex col>
        {spectrumWhitelistForm && (
          <Flex.Item marginBottom={4}>{spectrumWhitelistForm}</Flex.Item>
        )}
        {ergopadWhitelistForm}
      </Flex>
    )),
  );
